import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import { documentsService } from "../services/documents.services"
import axios from "../services/axios"
import { REQUEST_SOURCES, GET_DOCS_SOURCES, REQUEST_CUSTOM_TAGS, GET_CUSTOM_TAGS } from "../types/index"

// This will be run when the UPDATEACCOUNTDETAILS_REQUESTING
// Action is found by the watcher

const getSource = async () => {
	return await axios.get("/documents/sources").catch((e) => console.log(e))
}

function* sourcesFlow(action) {
	try {
		//No tiene payload, así que esto no mme hace falta
		//const { client, datos } = action

		//let user = getState().authtentication.loggedIn;
		//Para obtener el state se hace:
		const state = yield select()
		let user = state.authtentication.loggedIn
		if (user === true) {
			// const response = documentsService.getAvailableSources();
			const response = yield call(getSource)

			if (response.hasOwnProperty("data")) {
				const responseSource = response.data
				yield put({ type: GET_DOCS_SOURCES, payload: responseSource })
			}
		}
		/*
    const response = yield call(actualizarDatosApi, datos,client)
    yield put({ type: UPDATEACCOUNTDETAILS_SUCCESS, response })
    if (client.decode.is_verified===false){
      yield delay(1); // Add delay
      yield put(push('/verificacion'));
      document.location='/verificacion';
    }else{
      yield put(push('/dashboard'));
    }*/
	} catch (error) {
		// if the api call fails, it will "put" the UPDATEACCOUNTDETAILS_ERROR
		// into the dispatch along with the error.
		console.log(error)
		//yield put({ type: UPDATEACCOUNTDETAILS_ERROR, error })
	}
}

const getTags = async () => {
	return await axios.get("/tag").catch((e) => console.log(e))
}

function* customTagFlow(action) {
	try {
		const state = yield select()
		let user = state.authtentication.loggedIn
		if (user === true) {
			// const response = documentsService.getAvailableCustomTags();
			const response = yield call(getTags)
			if (response.hasOwnProperty("data") && response.data.hasOwnProperty("tags")) {
				const responseTags = response.data.tags
				yield put({ type: GET_CUSTOM_TAGS, payload: responseTags })
			}
		}
	} catch (error) {
		// if the api call fails, it will "put" the UPDATEACCOUNTDETAILS_ERROR
		// into the dispatch along with the error.
		console.log(error)
		//yield put({ type: UPDATEACCOUNTDETAILS_ERROR, error })
	}
}

// Watches for the UPDATEACCOUNTDETAILS_REQUESTING action type
// When it gets it, it will call verificarFlow()
// WITH the action we dispatched
function* sourcesWatcher() {
	// takeLatest() takes the LATEST call of that action and runs it
	// if we we're to use takeEvery, it would take every single
	// one of the actions and kick off a new task to handle it
	// CONCURRENTLY!!!
	yield takeLatest(REQUEST_SOURCES, sourcesFlow)
	yield takeLatest(REQUEST_CUSTOM_TAGS, customTagFlow)
}

export default sourcesWatcher
